<template>
<div class="objectiveQues">
    <p class="margin-10">学员回答：{{item.uselanswer}}</p>
    <p class="margin-10 flex-box">参考答案：<span v-html="item.referenceanswer"></span></p>
    <!--主观题(查看0)-->
    <div v-if="pageType==0">
        <p class="margin-10">打分：{{item.userscore}}分</p>
        <p class="checkMemoBox" style="display: flex">评语：<b v-html="item.checkmemo?item.checkmemo:'暂无评语'"></b></p>
    </div>
    <!--主观题(批阅1)-->
    <div v-if="pageType==1">
        <p class="margin-10">打分：
            <el-input v-model="item.userscore"></el-input>
            分
        </p>
        <p class="comment">评语：
            <uEditor :content="item.checkmemo" ref="uEditor1" @getUEditorContent="getTrySeeContent"
                     :index="index"></uEditor>
        </p>
    </div>
</div>
</template>

<script>
    import UEditor from 'base/uEditor/uEditor2'
export default {
    name: 'objectiveQues',
    props: ['item', 'index', 'objectiveList'],
    data() {
        return {
            pageType: this.$route.query.pageType
        }
    },
    mounted() {
    },
    methods: {
        getTrySeeContent(index, content) {
            this.$emit('changeCheckmemo', {index: this.index, content: content !== undefined ? content : index})
            // console.log(this.index, content)
            // let list = (this.index + '' ).split('-')
            // if (list > 1) {
            //     this.objectiveList[list[0]].questioninfo[list[1]].checkmemo = content
            // } else {
            //     this.objectiveList[list[0]].checkmemo = content
            // }
        },
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        UEditor
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.objectiveQues {
}
</style>
